import React from 'react';

import styled from 'styled-components';

const Container = styled.div.attrs({ className: 'mini-scroll' })`
  min-width: 0;
  overflow-y: auto;
  padding: 31px 30px 28px 29px;
  background: var(--background-gray);
`;

type Props = {
  children: React.ReactNode;
};

const CreateEditActionPlansModalRight = ({ children }: Props) => {
  return <Container>{children}</Container>;
};

export default CreateEditActionPlansModalRight;
